import React, {Component, Fragment, useEffect, useState} from 'react'
import Counter from "../../../components/counter";
import ProgressBar from "@ramonak/react-progress-bar";
import {getDeviseSymbol} from "../../../../../i18n";

export default function ScreenBarPartner({context,campagneData,mini}){

    const partnerMontant=campagneData?.partnerMontant || 1

    const total=campagneData.stats.total.sum.total/partnerMontant


    let bonus=null
    let _objectif=campagneData.objectif
    if(_objectif<total && Array.isArray(campagneData?.bonus) && campagneData?.bonus.length>0){
        bonus=campagneData.bonus.find(b=>b>total)
        if(!bonus){
            bonus=campagneData.bonus.at(-1)
        }
    }
    if(bonus){
        _objectif=bonus
    }

    const percent=(_objectif>0 ? (total/_objectif)*100 : 0)
    const displayPercent=(Number(campagneData.objectif)>0 ? (total/campagneData.objectif)*100 : 0)
    let progressColor=campagneData.config?.primaryColor || "#13A0BB"
    let progressLabelColor="#000"

    let donorName=campagneData.config?.donorName || "M2"

    const formater=new Intl.NumberFormat('fr-FR', { maximumFractionDigits:0 })


    return (
        <Fragment>
            <div className={"d-flex justify-content-around align-items-center"} style={{flexDirection: "column", gap: 0}}>

                <div style={{display:"flex",flexDirection:"column",height:"50vh",width:"100vw"}}>
                    <span className={"screen-count-text2"} style={{marginTop: "0vh",textAlign:"center",fontFamily:"Cerapro-Bold",fontSize:"28vh",color:"#FFF"}}><Counter number={total} decimals={0} preserveValue/> M²</span>
                </div>


                <div style={{backgroundColor:"#FFF",padding:10,height:"10vh",width:"60vw",borderRadius:50,overflow:"hidden",marginTop:"-3vh"}} >
                    <div style={{borderRadius:50,width:"100%",height:"100%",backgroundColor:"#C9CFF7",overflow:"hidden"}}>
                        <div style={{borderRadius:50,width:percent+"%",height:"100%",backgroundColor:"#2D90FF",background:"linear-gradient(90deg,#2D90FFA0 0%, #2D90FF 50%)",display:"flex",justifyContent:"flex-end",alignItems:'center',paddingRight:15}}>
                            {displayPercent>=20 && (
                                <span style={{fontSize:"4vh",color:"#FFF"}}>
                                    <span style={{fontFamily:"Cerapro-Bold"}}>{Math.floor(displayPercent)}</span>%
                                </span>
                            )}
                        </div>
                    </div>
                </div>


            </div>
        </Fragment>
    )
}
